// src/components/Header.js
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { ShoppingCart, Menu, X } from 'lucide-react';
import { useCart } from '../context/CartContext'; 
import './Header.css';

const Header = () => {
    const { cartItemCount } = useCart();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const closeMobileMenu = () => setIsMobileMenuOpen(false);

  return (
    <header className="main-header">
      <div className="logo-container">
        <img src="/images/logo.png" alt="Logo de la Empresa" className="logo" />
      </div>

      {/* Navegación Desktop */}
      <nav className="main-nav desktop-nav">
        <NavLink to="/" className="nav-link">Inicio</NavLink>
        <NavLink to="/catalogo" className="nav-link">Catálogo</NavLink>
        <NavLink to="/domicilio" className="nav-link">Domicilio</NavLink>
        <NavLink to="/contacto" className="nav-link">Contacto</NavLink>
      </nav>

      {/* Navegación Móvil - Links principales siempre visibles */}
      <nav className="main-nav mobile-main-nav">
        <NavLink to="/" className="nav-link">Inicio</NavLink>
        <NavLink to="/catalogo" className="nav-link">Catálogo</NavLink>
      </nav>

      {/* Botón menú móvil - Solo para más opciones */}
      <button 
        className="mobile-menu-toggle"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        aria-label="Toggle menu"
      >
        {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Menú desplegable móvil */}
      {isMobileMenuOpen && (
        <nav className="mobile-dropdown-menu">
          <NavLink to="/domicilio" className="nav-link" onClick={closeMobileMenu}>Domicilio</NavLink>
          <NavLink to="/contacto" className="nav-link" onClick={closeMobileMenu}>Contacto</NavLink>
        </nav>
      )}

      <div className="cart-container">
        <NavLink to="/carrito" className="cart-link">
                <ShoppingCart color="#2C2C2C" size={28} />
          {/* 3. Muestra el contador si hay productos */}
          {cartItemCount > 0 && (
            <span className="cart-badge">{cartItemCount}</span>
          )}
        </NavLink>
      </div>
    </header>
  );
};

export default Header;